import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    button: 'w-8 flex center duration',
    container: 'h-8 b b-grey-40 rounded-xs i-flex',
    display: 'w-10 flex center b-x b-grey-40 text-md duration'
  }
} satisfies VfConfig['stepper']
